import { useEffect } from 'react'
import { Sections, SetStateType } from '../definitions'
import isSmallScreen from '../utils/isSmallScreen'

type useSetFirstActiveSectionTitleProps = {
  setState: SetStateType
  sections: Sections
  activeSectionTitle?: string
}

function useSetFirstActiveSectionTitle({
  setState,
  sections,
  activeSectionTitle,
}: useSetFirstActiveSectionTitleProps) {
  useEffect(() => {
    if (!Boolean(activeSectionTitle) && !isSmallScreen()) {
      setState(sections[0])
    }
  }, [setState, sections, activeSectionTitle])
}

export default useSetFirstActiveSectionTitle
